import { useMutation, useQueryClient } from "@tanstack/react-query";
import { isAxiosError } from "axios";
import { createRequest } from "../services/discuss.service";
import { ICreateRequestRequest } from "../types/discuss.types";
import { toast } from "sonner";

/**
 * Hook for creating a request in the request library
 */
export const useCreateRequest = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (data: ICreateRequestRequest) => createRequest(data),
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries({ queryKey: ["requests", variables.type] });
      toast.success("Saved to Library!", {
        description: "Request saved successfully to the request library",
      });
    },
    onError: (error) => {
      console.error("Failed to create request:", error);
      const data = isAxiosError<{ detail?: string }>(error) ? error.response?.data : undefined;
      const message =
        typeof data?.detail === "string"
          ? data.detail
          : "Failed to save to request library. Please try again.";
      toast.error("Save Failed", { description: message });
    },
  });
};
